<script lang="ts" setup>
interface Props {
  name: string;
  filled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  filled: false,
});

const iconComponentName = computed(() => `icon-${props.name}`);
</script>

<template>
  <component
    :is="iconComponentName"
    :font-controlled="false"
    :filled="filled"
  />
</template>
